import gql from 'graphql-tag'

export const POSITION_MUTATION_UPDATE = gql`
  mutation UpdatePosition($input: UpdatePositionInput!) {
  updatePosition(input: $input) {
    isSuccessful
    message
    position {
     departmentId
      departmentName
      hasRelation
      isPosition
      level
      name
      structureId
      unitId
      unitName
    }
  }
}
`

export const POSITION_MUTATION_CREATE = gql`
  mutation CreatePosition($input: CreatePositionInput!) {
  createPosition(input: $input) {
    isSuccessful
    message
    position {
      departmentId
      departmentName
      hasRelation
      isPosition
      level
      name
      structureId
      unitId
      unitName
    }
  }
}
`

export const GET_POSITION = gql`
query Positions($filter: GetPositionsFilter) {
  positions(filter: $filter) {
    isSuccessful
    message
    positions {
      data {
        structureId
        companyId
        name
        level
        isPosition
        unitId
        unitName
        departmentId
        departmentName
        hasRelation
      }
      pagination {
        total
        page
        show
        startCursor
        endCursor
      }
    }
    status
  }
}
`